import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { TendersService } from "../../../services/user/tenders.services";
import { handleNotify, TOASTER_TYPE, TOASTER_POSITION } from "../../common/notification/toaster_notify.component";
import { useSelector } from "react-redux";
import moment from "moment";
import { Editor } from "@tinymce/tinymce-react";
import { UserServices } from "../../../services/user/user.services";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import striptags from "striptags";
import Select from 'react-select';
import { getDateFormat, parseCultureDate } from "../../../utility";

const AddTenderComponent = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const tenderId = location.state?.tenderId || 0;
    const isEditMode = !!tenderId;
    const selectedStore = useSelector((state) => state?.user?.selectedStoreId);
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);

    const formik = useFormik({
        initialValues: {
            tenderId: 0,
            tenderNo: "",
            userId: 0,
            modelNo: "",
            hospitalName: "",
            itemDetails: "",
            address: "",
            emdType: "",
            emdAmount: 0,
            emdReceivedDate: new Date(),
            emdDetails: "",
            emdRemarks: "",
            sdType: "",
            sdAmount: 0,
            sdReceivedDate: new Date(),
            sdMatureDate: new Date(),
            sdDetails: "",
            sdRemarks: "",
            pbgType: "",
            pbgAmount: 0,
            pbgReceivedDate: new Date(),
            pbgMatureDate: new Date(),
            pbgDetails: "",
            pbgRemarks: "",
            machineInstallationDate: new Date(),
            machineQuantity: "",
            warranty: "",
            basicRate: 0,
            gstAmount: 0,
            total: 0,
            remarks: "",
            paymentDetails: "",
            storeId: selectedStore,
        },
        onSubmit: async (values) => {
            try {
                let cleanedRemarks = striptags(values.remarks);
                let cleanedPaymentDetails = striptags(values.paymentDetails);
                setLoading(true);
                const data = {
                    ...values,
                    emdReceivedDate: values.emdReceivedDate ? new Date(values.emdReceivedDate).toISOString() : null,
                    sdReceivedDate: values.sdReceivedDate ? new Date(values.sdReceivedDate).toISOString() : null,
                    sdMatureDate: values.sdMatureDate ? new Date(values.sdMatureDate).toISOString() : null,
                    pbgReceivedDate: values.pbgReceivedDate ? new Date(values.pbgReceivedDate).toISOString() : null,
                    pbgMatureDate: values.pbgMatureDate ? new Date(values.pbgMatureDate).toISOString() : null,
                    machineInstallationDate: values.machineInstallationDate ? new Date(values.machineInstallationDate).toISOString() : null,

                    userId: Number(values.userId),
                    remarks: cleanedRemarks,
                    paymentDetails: cleanedPaymentDetails
                }; if (isEditMode) {

                    await TendersService.updateTenderById(tenderId, data)
                        .then((response) => {
                            if (response) {
                                navigate("/tenders");
                            }
                        });
                } else {
                    await TendersService.addNewTender(data)
                        .then((response) => {
                            if (response) {
                                navigate("/tenders");
                            }
                        });
                }
            } catch (error) {
                console.error("Error while submitting form:", error);
                handleNotify(
                    "An error occurred while saving the tender.",
                    TOASTER_TYPE.ERROR,
                    TOASTER_POSITION.TOP_RIGHT
                );
            } finally {
                setLoading(false);
            }
        },
    });

    useEffect(() => {
        if (isEditMode) {
            const fetchTenderDetail = async () => {
                try {
                    const data = await TendersService.getTenderById(tenderId);
                    formik.setValues({
                        tenderNo: data?.tenderNo,
                        userId: data?.userId,
                        modelNo: data?.modelNo,
                        hospitalName: data?.hospitalName,
                        itemDetails: data?.itemDetails,
                        address: data?.address,
                        emdType: data?.emdType,
                        emdAmount: data?.emdAmount,
                        emdReceivedDate: parseCultureDate(data.emdReceivedDate),
                        emdDetails: data?.emdDetails,
                        emdRemarks: data?.emdRemarks,
                        sdType: data?.sdType,
                        sdAmount: data?.sdAmount,
                        sdReceivedDate: parseCultureDate(data.sdReceivedDate),
                        sdMatureDate: parseCultureDate(data.sdMatureDate),
                        sdDetails: data?.sdDetails,
                        sdRemarks: data?.sdRemarks,
                        pbgType: data?.pbgType,
                        pbgAmount: data?.pbgAmount,
                        pbgReceivedDate: parseCultureDate(data.pbgReceivedDate),
                        pbgMatureDate: parseCultureDate(data.pbgMatureDate),
                        pbgDetails: data?.pbgDetails,
                        pbgRemarks: data?.pbgRemarks,
                        machineInstallationDate: parseCultureDate(data.machineInstallationDate),
                        machineQuantity: data?.machineQuantity,
                        warranty: data?.warranty,
                        basicRate: data?.basicRate,
                        gstAmount: data?.gstAmount,
                        total: data?.total,
                        remarks: data?.remarks,
                        paymentDetails: data?.paymentDetails
                    });
                } catch (error) {
                    console.log("Error fetching tender details", error);
                }
            };
            fetchTenderDetail();
        }
    }, []);

    // const handleDateChange = (date, field) => {
    //     formik.setFieldValue(field, moment(date).format('YYYY-MM-DD'));
    // };

    //fetch Users
    const fetchUsers = async () => {
        try {
            const response = await UserServices.getAllUsers();
            const sortedUsers = response.sort((a, b) => a.userId - b.userId);
            const usersOptions = sortedUsers.map(user => ({
                value: user.userId,
                label: user.username
            }));
            if (!formik.values.userId && usersOptions.length > 0) {
                formik.setFieldValue('userId', usersOptions[0].value)
            }
            setUsers(usersOptions);
        } catch (error) {
            console.error("Error fetching Users role:", error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleBackClick = () => {
        navigate("/tenders");
    };

    return (
        <div className="page-wrapper m-0">
            <div className="page-content">
                <div className="page-breadcrumb d-flex align-items-center mb-3">
                    <div
                        className="breadcrumb-title pe-3 text-primary fw-bold fs-4 cursor-pointer"
                        onClick={handleBackClick}
                    >
                        Tenders</div>
                    <div className="ps-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0 p-0">
                                <li className="breadcrumb-item active" aria-current="page">
                                    {isEditMode ? "Edit Tender" : "New Tender"}
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="ms-auto">
                        <button
                            type="button"
                            className="btn btn-outline-secondary me-2 px-4 py-2 rounded-3 shadow-sm hover-effect"
                            onClick={handleBackClick}
                        >
                            Back
                        </button>
                    </div>
                </div>

                <div className="card radius-10 border-top border-0 border-4 border-primary p-5">
                    <div className="card-body form-container">
                        <form onSubmit={formik.handleSubmit} className="mt-4">
                            {/* Tender No & Assigned To */}
                            <div className="row mb-4">
                                <div className="col-md-6 col-12">
                                    <label htmlFor="tenderNo" className="form-label d-flex">
                                        Tender No
                                    </label>
                                    <input
                                        type="text"
                                        id="tenderNo"
                                        name="tenderNo"
                                        className="form-control"
                                        placeholder="Enter Tender No"
                                        value={formik.values.tenderNo}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                <div className="col-md-6 col-12">
                                    <label htmlFor="userId" className="form-label d-flex">
                                        Assigned To
                                    </label>
                                    <div className="text-start">
                                        <Select
                                            id="userId"
                                            name="userId"
                                            options={users}
                                            value={users.find(option => option.value === formik.values.userId)}
                                            onChange={(selectedOption) => formik.setFieldValue('userId', selectedOption.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Model No & Hospital Name */}
                            <div className="row mb-4">
                                <div className="col-md-6 col-12">
                                    <label htmlFor="modelNo" className="form-label d-flex">
                                        Model No
                                    </label>
                                    <input
                                        type="text"
                                        id="modelNo"
                                        name="modelNo"
                                        className="form-control"
                                        placeholder="Enter Model No"
                                        value={formik.values.modelNo}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                <div className="col-md-6 col-12">
                                    <label htmlFor="hospitalName" className="form-label d-flex">
                                        Hospital Name
                                    </label>
                                    <input
                                        type="text"
                                        id="hospitalName"
                                        name="hospitalName"
                                        className="form-control"
                                        placeholder="Enter Hospital Name"
                                        value={formik.values.hospitalName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                            </div>

                            {/* Item Details & Address */}
                            <div className="row mb-4">
                                <div className="col-md-6 col-12">
                                    <label htmlFor="itemDetails" className="form-label d-flex">
                                        Item Details
                                    </label>
                                    <textarea
                                        id="itemDetails"
                                        name="itemDetails"
                                        className="form-control"
                                        placeholder="Enter Item Details"
                                        value={formik.values.itemDetails}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                <div className="col-md-6 col-12">
                                    <label htmlFor="address" className="form-label d-flex">
                                        Address
                                    </label>
                                    <textarea
                                        id="address"
                                        name="address"
                                        className="form-control"
                                        placeholder="Enter Address"
                                        value={formik.values.address}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                            </div>
                            {/* EMD Tender Section */}
                            <hr className="radius-10 border-top border-0 border-4 border-primary" />

                            <h5 className="form-label d-flex">
                                EMD Type
                            </h5>
                            <div className="row mb-4 mt-5">
                                <div className="col-md-6 col-12">
                                    <label htmlFor="emdType" className="form-label d-flex">
                                        EMD Type
                                    </label>
                                    <input
                                        type="text"
                                        id="emdType"
                                        name="emdType"
                                        className="form-control"
                                        placeholder="Enter EMD Type"
                                        value={formik.values.emdType}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.emdType && formik.errors.emdType ? (
                                        <div className="text-danger">{formik.errors.emdType}</div>
                                    ) : null}
                                </div>

                                <div className="col-md-3 col-12">
                                    <label htmlFor="emdAmount" className="form-label d-flex">
                                        EMD Amount
                                    </label>
                                    <input
                                        type="text"
                                        id="emdAmount"
                                        name="emdAmount"
                                        className="form-control"
                                        placeholder="Enter EMD Amount"
                                        value={formik.values.emdAmount}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>

                                <div className="col-md-3 col-12">
                                    <label htmlFor="emdReceivedDate" className="form-label d-flex">
                                        EMD Received Date
                                    </label>
                                    <div className="d-flex">
                                        <DatePicker
                                            selected={parseCultureDate(formik.values.emdReceivedDate)}
                                            // selected={formik.values.followUpDate}
                                            onChange={(date) => formik.setFieldValue("emdReceivedDate", date)}
                                            onBlur={formik.handleBlur}
                                            name="emdReceivedDate"
                                            dateFormat={getDateFormat()}
                                            className={`form-control ${formik.touched.emdReceivedDate && formik.errors.emdReceivedDate ? 'is-invalid' : ''}`}
                                            id="emdReceivedDate"
                                            menuPortalTarget={document.body}
                                        />
                                        {formik.touched.emdReceivedDate && formik.errors.emdReceivedDate ? (
                                            <div className="text-danger">{formik.errors.emdReceivedDate}</div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-4">
                                <div className="col-md-6 col-12">
                                    <label htmlFor="emdDetails" className="form-label d-flex">
                                        EMD Details
                                    </label>
                                    <textarea
                                        id="emdDetails"
                                        name="emdDetails"
                                        className="form-control"
                                        placeholder="Enter EMD Details"
                                        value={formik.values.emdDetails}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                <div className="col-md-6 col-12">
                                    <label htmlFor="emdRemarks" className="form-label d-flex">
                                        EMD Remarks
                                    </label>
                                    <textarea
                                        id="emdRemarks"
                                        name="emdRemarks"
                                        className="form-control"
                                        placeholder="Enter EMD Remarks"
                                        value={formik.values.emdRemarks}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                            </div>
                            {/*  SD Type Section */}
                            <hr className="radius-10 border-top border-0 border-4 border-primary" />
                            <h5 className="form-label d-flex">
                                SD Tender
                            </h5>

                            <div className="row mb-4 mt-5">
                                <div className="col-md-6 col-12">
                                    <label htmlFor="sdType" className="form-label d-flex">
                                        SD Type
                                    </label>
                                    <input
                                        type="text"
                                        id="sdType"
                                        name="sdType"
                                        className="form-control"
                                        placeholder="Enter SD Type"
                                        value={formik.values.sdType}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>

                                <div className="col-md-2 col-12">
                                    <label htmlFor="sdAmount" className="form-label d-flex">
                                        SD Amount
                                    </label>
                                    <input
                                        type="text"
                                        id="sdAmount"
                                        name="sdAmount"
                                        className="form-control"
                                        placeholder="Enter SD Amount"
                                        value={formik.values.sdAmount}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>

                                <div className="col-md-2 col-12">
                                    <label htmlFor="sdReceivedDate" className="form-label d-flex">
                                        SD Received Date
                                    </label>
                                    <DatePicker
                                        selected={parseCultureDate(formik.values.sdReceivedDate)}
                                        onChange={(date) => formik.setFieldValue("sdReceivedDate", date)}
                                        onBlur={formik.handleBlur}
                                        name="sdReceivedDate"
                                        dateFormat={getDateFormat()}
                                        className={`form-control ${formik.touched.sdReceivedDate && formik.errors.sdReceivedDate ? 'is-invalid' : ''}`}
                                        id="sdReceivedDate"
                                        menuPortalTarget={document.body}
                                    />
                                    {formik.touched.sdReceivedDate && formik.errors.sdReceivedDate ? (
                                        <div className='text-danger'>{formik.errors.sdReceivedDate}</div>
                                    ) : null}
                                </div>

                                <div className="col-md-2 col-12">
                                    <label htmlFor="sdMatureDate" className="form-label d-flex">
                                        SD Mature Date
                                    </label>
                                    <DatePicker
                                        selected={parseCultureDate(formik.values.sdMatureDate)}
                                        onChange={(date) => formik.setFieldValue("sdMatureDate", date)}
                                        onBlur={formik.handleBlur}
                                        name="sdMatureDate"
                                        dateFormat={getDateFormat()}
                                        className={`form-control ${formik.touched.sdMatureDate && formik.errors.sdMatureDate ? 'is-invalid' : ''}`}
                                        id="sdMatureDate"
                                        menuPortalTarget={document.body}
                                    />
                                    {formik.touched.sdMatureDate && formik.errors.sdMatureDate ? (
                                        <div className='text-danger'>{formik.errors.sdMatureDate}</div>
                                    ) : null}
                                </div>
                            </div>

                            <div className="row mb-4">
                                <div className="col-md-6 col-12">
                                    <label htmlFor="sdDetails" className="form-label d-flex">
                                        SD Details
                                    </label>
                                    <textarea
                                        id="sdDetails"
                                        name="sdDetails"
                                        className="form-control"
                                        placeholder="Enter SD Details"
                                        value={formik.values.sdDetails}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                <div className="col-md-6 col-12">
                                    <label htmlFor="sdRemarks" className="form-label d-flex">
                                        SD Remarks
                                    </label>
                                    <textarea
                                        id="sdRemarks"
                                        name="sdRemarks"
                                        className="form-control"
                                        placeholder="Enter SD Remarks"
                                        value={formik.values.sdRemarks}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                            </div>
                            <hr className="radius-10 border-top border-0 border-4 border-primary" />
                            <h5 className="form-label d-flex">
                                PBG Tender
                            </h5>
                            <div className="row mb-4 mt-5">
                                {/* PBG Type */}
                                <div className="col-md-6 col-12">
                                    <label htmlFor="pbgType" className="form-label d-flex">
                                        PBG Type
                                    </label>
                                    <input
                                        type="text"
                                        id="pbgType"
                                        name="pbgType"
                                        className="form-control"
                                        placeholder="Enter PBG Type"
                                        value={formik.values.pbgType}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {/* PBG Amount */}
                                <div className="col-md-2 col-12">
                                    <label htmlFor="pbgAmount" className="form-label d-flex">
                                        PBG Amount
                                    </label>
                                    <input
                                        type="text"
                                        id="pbgAmount"
                                        name="pbgAmount"
                                        className="form-control"
                                        placeholder="Enter PBG Amount"
                                        value={formik.values.pbgAmount}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {/* PBG Received Date */}
                                <div className="col-md-2 col-12">
                                    <label htmlFor="pbgReceivedDate" className="form-label d-flex">
                                        PBG Received Date
                                    </label>
                                    <DatePicker
                                        selected={parseCultureDate(formik.values.pbgReceivedDate)}
                                        // selected={formik.values.pbgReceivedDate}
                                        onChange={(date) => formik.setFieldValue("pbgReceivedDate", date)}
                                        onBlur={formik.handleBlur}
                                        name="pbgReceivedDate"
                                        dateFormat={getDateFormat()}
                                        className={`form-control ${formik.touched.pbgReceivedDate && formik.errors.pbgReceivedDate ? 'is-invalid' : ''}`}
                                        id="pbgReceivedDate"
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                                {/* PBG Mature Date */}
                                <div className="col-md-2 col-12">
                                    <label htmlFor="pbgMatureDate" className="form-label d-flex">
                                        PBG Mature Date
                                    </label>
                                    <DatePicker
                                        selected={parseCultureDate(formik.values.pbgMatureDate)}
                                        onChange={(date) => formik.setFieldValue("pbgMatureDate", date)}
                                        onBlur={formik.handleBlur}
                                        name="pbgMatureDate"
                                        dateFormat={getDateFormat()}
                                        className={`form-control ${formik.touched.pbgMatureDate && formik.errors.pbgMatureDate ? 'is-invalid' : ''}`}
                                        id="pbgMatureDate"
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>
                            <div className="row mb-4">
                                {/* PBG Details */}
                                <div className="col-md-6 col-12">
                                    <label htmlFor="pbgDetails" className="form-label d-flex">
                                        PBG Details
                                    </label>
                                    <textarea
                                        id="pbgDetails"
                                        name="pbgDetails"
                                        className="form-control"
                                        placeholder="Enter PBG Details"
                                        value={formik.values.pbgDetails}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {/* PBG Remarks */}
                                <div className="col-md-6 col-12">
                                    <label htmlFor="pbgRemarks" className="form-label d-flex">
                                        PBG Remarks
                                    </label>
                                    <textarea
                                        id="pbgRemarks"
                                        name="pbgRemarks"
                                        className="form-control"
                                        placeholder="Enter PBG Remarks"
                                        value={formik.values.pbgRemarks}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                            </div>
                            <hr className="radius-10 border-top border-0 border-4 border-primary" />
                            <h5 className="form-label d-flex">
                                Tender Details
                            </h5>
                            <div className="row mb-4 mt-5">
                                {/* Machine Installation Date */}
                                <div className="col-md-4 col-12">
                                    <label htmlFor="machineInstallationDate" className="form-label d-flex">
                                        Machine Installation Date
                                    </label>
                                    <div className="d-flex">
                                        <DatePicker
                                            selected={parseCultureDate(formik.values.machineInstallationDate)}
                                            onChange={(date) => formik.setFieldValue("machineInstallationDate", date)}
                                            onBlur={formik.handleBlur}
                                            name="machineInstallationDate"
                                            dateFormat={getDateFormat()}
                                            className={`form-control ${formik.touched.machineInstallationDate && formik.errors.machineInstallationDate ? 'is-invalid' : ''}`}
                                            id="machineInstallationDate"
                                            menuPortalTarget={document.body}
                                        />
                                    </div>
                                </div>
                                {/* Machine Quantity */}
                                <div className="col-md-4 col-12">
                                    <label htmlFor="machineQuantity" className="form-label d-flex">
                                        Machine Quantity
                                    </label>
                                    <input
                                        type="text"
                                        id="machineQuantity"
                                        name="machineQuantity"
                                        className="form-control"
                                        placeholder="Enter Machine Quantity"
                                        value={formik.values.machineQuantity}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {/* Warranty */}
                                <div className="col-md-4 col-12">
                                    <label htmlFor="warranty" className="form-label d-flex">
                                        Warranty
                                    </label>
                                    <input
                                        type="text"
                                        id="warranty"
                                        name="warranty"
                                        className="form-control"
                                        placeholder="Enter Warranty Details"
                                        value={formik.values.warranty}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                            </div>
                            <div className="row mb-4">
                                {/* Basic Rate */}
                                <div className="col-md-4 col-12">
                                    <label htmlFor="basicRate" className="form-label d-flex">
                                        Basic Rate
                                    </label>
                                    <input
                                        type="text"
                                        id="basicRate"
                                        name="basicRate"
                                        className="form-control"
                                        placeholder="Enter Basic Rate"
                                        value={formik.values.basicRate}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {/* GST Amount */}
                                <div className="col-md-4 col-12">
                                    <label htmlFor="gstAmount" className="form-label d-flex">
                                        GST Amount
                                    </label>
                                    <input
                                        type="text"
                                        id="gstAmount"
                                        name="gstAmount"
                                        className="form-control"
                                        placeholder="Enter GST Amount"
                                        value={formik.values.gstAmount}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {/* Total */}
                                <div className="col-md-4 col-12">
                                    <label htmlFor="total" className="form-label d-flex">
                                        Total
                                    </label>
                                    <input
                                        type="text"
                                        id="total"
                                        name="total"
                                        className="form-control"
                                        placeholder="Enter Total Amount"
                                        value={formik.values.total}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                            </div>
                            <div className="col-12 mb-5 mt-5">
                                <label htmlFor="paymentDetails" className="form-label d-flex">
                                    Payment Details
                                </label>
                                <Editor
                                    value={formik.values.paymentDetails}
                                    tinymceScriptSrc={`${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`}
                                    init={{
                                        height: 300,
                                        menubar: true,
                                        plugins: [
                                            "advlist autolink lists link image charmap print preview anchor",
                                            "searchreplace visualblocks code fullscreen",
                                            "insertdatetime media table paste code help wordcount",
                                        ],
                                        toolbar:
                                            "undo redo | formatselect | bold italic backcolor | \
                                            alignleft aligncenter alignright | bullist numlist outdent indent | \
                                            link image",
                                    }}
                                    onEditorChange={(content) =>
                                        formik.setFieldValue("paymentDetails", content)
                                    }
                                />
                            </div>
                            <div className="col-12 mb-5">
                                <label htmlFor="remarks" className="form-label d-flex">
                                    Remarks
                                </label>
                                <Editor
                                    value={formik.values.remarks}
                                    init={{
                                        height: 300,
                                        menubar: true,
                                        plugins: [
                                            "advlist autolink lists link image charmap print preview anchor",
                                            "searchreplace visualblocks code fullscreen",
                                            "insertdatetime media table paste code help wordcount",
                                        ],
                                        toolbar:
                                            "undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright | bullist numlist outdent indent | link image ",

                                    }}
                                    onEditorChange={(content, editor) => formik.setFieldValue("remarks", content)}
                                />
                            </div>
                            <hr />
                            <div className="d-flex flex-column flex-md-row mt-4 justify-content-end">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary mb-2 mb-md-0 me-2 px-4 py-2 rounded-3 shadow-sm hover-effect"
                                    onClick={handleBackClick}
                                >
                                    Back
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary px-4 py-2 rounded-3 shadow-sm hover-effect"
                                    disabled={loading}
                                >
                                    {loading ? "Saving..." : isEditMode ? "Update" : "Save"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddTenderComponent;
